/**
 * Formata um valor numérico em uma string no formato de moeda brasileira (R$ #.###,##).
 *
 * Se o valor for um número, ele é convertido para uma string com duas casas decimais.
 * O valor é dividido em reais e centavos, e os reais são formatados com pontos como separadores de milhar.
 * O resultado final é uma string no formato "R$ X.XXX,XX".
 *
 * @param {String|Number} money
 * @returns {String}
 */
const maskMoney = (money) => {
  if (!money) return "R$ 0,00";

  if (typeof money === "number") money = money.toFixed(2);

  let stringCentavos = money.split(".")[1];
  let stringReais = money.split(".")[0];

  let newStringReaisRevert = "";

  let cont = 0;

  for (let i = stringReais.length - 1; i >= 0; i--) {
    let num = stringReais[i];
    if (cont % 3 === 0 && cont !== 0) newStringReaisRevert += "." + num;
    else newStringReaisRevert += num;
    cont++;
  }

  let newStringReais = "";

  for (let i = newStringReaisRevert.length - 1; i >= 0; i--)
    newStringReais += newStringReaisRevert[i];

  const newStringMoney = "R$ " + newStringReais + "," + stringCentavos;

  return newStringMoney;
};

export default maskMoney;
